<template>
  <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex">
    <a
      :href="model.publicUrl"
      @click.prevent="openPublicUrl(model.publicUrl)"
      class="tw-relative card model-car model-card mb-4 h-auto w-100 cursor-pointer"
    >
      <div class="tw-absolute tw-top-2 tw-left-2 tw-right-2 tw-flex tw-items-center tw-gap-1.5 model-card__badge-row">
        <span class="bic-card__featured-badge" v-if="isBic">Kiemelt ajánlat</span>
        <span class="badge badge-danger badge-sm text-uppercase" v-if="model.stock_number > 0">Készleten</span>
        <month-badge v-else  :date="model.take_over_month" />
      </div>
      <car-image-rotator
        :angles="model.imageAngles"
        :fallback="model.image"
        :alt="generateModelAltText()"
        :zoom="rotatorZoom"
      />
      <div class="card-body d-flex flex-column">
        <h4 class="h3 card-title mb-1">
          <span class="make-name">{{ model.make.name }}</span> {{ model.MODNameGrp1 }} {{ model.body_type }}
        </h4>
        <p class="card-text model-availability model-available mb-0">
          <i class="fas fa-circle fa-1x"></i>
          {{ model.type_count }} változat rendelhető
        </p>
        <div class="mb-4">
          <p
            v-if="model.available_number > 0"
            class="model-availability model-available mt-0"
            @click.prevent="openStock(model.publicUrl)"
          >
            <i class="fas fa-circle fa-1x"></i>
            {{ model.available_number }} darab elérhető
          </p>
          <p
            v-if="model.config && model.config.card_text"
            class="card-text mb-4"
          >
            {{ model.config.card_text }}
          </p>
        </div>
        <button
          type="button"
          class="btn btn-block btn-primary btn-sm mt-auto"
        >
        <template v-if="getCalculatedPrice">
            {{ getCalculatedPrice | currency }} Ft + {{ isExactTerm ? 'ÁFA' : 'ÁFÁ-tól' }}
        </template>
          <template v-else>
            Hívjon bennünket!
          </template>
        </button>
      </div>
    </a>
  </div>
</template>

<script>
    import Vue from 'vue';
    import { namespace } from 'vuex-class';
    import { Component, Prop } from 'vue-property-decorator';
    import { calculateModelPrice } from '../services/modelPrice';

    const priceSearchModule = namespace('price_search');

  @Component
  export default class ModelCard extends Vue {

    @priceSearchModule.Getter('getContractLength') contractLength;
    @priceSearchModule.Getter('getAnnualMileage') annualMileage;
    @priceSearchModule.State('filters') filters;
    @priceSearchModule.Getter('getPrinp2') prinp2;
    @priceSearchModule.Getter('getM') getM;
    @priceSearchModule.Getter('getInitialPaymentPercent') initialPaymentPercent;
    @priceSearchModule.Mutation('setModel') setModel;

    @Prop(Object) model;
    @Prop(String) page;


    created() {
      localStorage.setItem('filter', JSON.stringify(this.filters));
    }

    // The rental-fee search is the only list whose server query filters and orders on the selected
    // contract length/mileage cell, so it's the only one that may print an exact price instead of a
    // "from" price. Every other page still shows the cheapest cell (client R3).
    get isExactTerm() {
      return this.page === 'price';
    }

    get getCalculatedPrice() {
      const price = calculateModelPrice(this.model, {
        contractLength: this.contractLength,
        annualMileage: this.annualMileage,
        initialPaymentPercent: this.initialPaymentPercent,
        prinp2: this.prinp2,
        exactTerm: this.isExactTerm,
      });

      // The template tests this with v-if and prints it through the currency filter, so the
      // "no price" case must stay falsy-but-printable, exactly as before.
      return price === null ? '' : price;
    }

    get isBic() {
      // has_bic is MAX(type_configs.bic) from the model-list query; MySQL aggregates can
      // arrive as the string "0"/"1" through PDO, and "0" is truthy in JS.
      return Number(this.model.has_bic) > 0;
    }

    get rotatorZoom() {
      // Commercial vehicles (LCV vans/buses) already fill Imagin's relative frame —
      // skip the +25% CSS enlargement so tall bodies aren't clipped. Segment codes
      // 00030010 / 00030011 = commercial (Eurotax TYPTXTSeg1Cd2).
      const commercial = ['00030010', '00030011'];
      return commercial.includes(String(this.model.category)) ? 1.0 : 1.25;
    }

    openStock(url) {
      location.href = url + '?stock=1'
    }

    openPublicUrl(url) {

      if (["category", "makes", "flags", "models"].includes(this.page)) {
        this.filters.min_price = 0;
        this.filters.max_price = 0;
      }

      localStorage.setItem('filter',JSON.stringify(this.filters));
      location.href = url;
    }

    generateModelAltText() {
      const makeName = this.model.make?.name || 'Autó';
      const modelName = this.model.MODNameGrp1 || '';
      const bodyType = this.model.body_type || '';
      
      return `${makeName} ${modelName} ${bodyType} lízing`;
    }
  }
</script>

<style scoped>
  .model-card:hover {
    text-decoration: none;
  }

  .card-text {
    color: #676868;
  }

  .cursor-pointer{
    cursor: pointer;
  }

  /* 11 clears CarImageRotator's internal layers (10 = arrows/dots, 9 = duplicate frame) */
  .model-card__badge-row {
    z-index: 11;
    flex-wrap: wrap;
  }
</style>

